import { Spin } from "antd";
import { useSelector } from "react-redux";
import Detail from "../../../components/Details/Detail";
import { LABEL_TXT, TITLE_TXT } from "../../../constants/constants";
import DetailSubHeader from "../../../components/Details/DetailSubHeader";

const BankKYCDetails = ({ bankKYCDetailsData, isJV = false }) => {
  const { loading } = useSelector((state) => state?.business);

  const primaryBankDetails = bankKYCDetailsData?.bankDetails?.find(detail => !detail.isEscrow && detail.isPrimary) || {};
  const virtualBankDetails = bankKYCDetailsData?.bankDetails?.find(
    (detail) => detail.accountType === 'virtual' || detail.isEscrow
  ) || {};

  return (
    <div className="details-card-container">
      <div className="details-card">
        <DetailSubHeader title={TITLE_TXT.PRIM_BANK_DETS} />
        <Spin spinning={loading}>
          <div className="details-content">
            <Detail
              label={LABEL_TXT.ACC_HOL_NAME}
              value={primaryBankDetails?.accHolderName || "N/A"}
            />
            <Detail
              label={LABEL_TXT.ACC_NUM}
              value={primaryBankDetails?.accNum || "N/A"}
            />
            <Detail
              label={LABEL_TXT.ACC_IFSC}
              value={primaryBankDetails?.ifscCode || "N/A"}
            />
            <Detail
              label={LABEL_TXT.BANK_NAME}
              value={primaryBankDetails?.bankName || "N/A"}
            />
            <Detail
              label={LABEL_TXT.BRANCH_NAME}
              value={primaryBankDetails?.branchName || "N/A"}
            />
          </div>

          {!isJV && (
            <>
              <DetailSubHeader title={TITLE_TXT.VA_BANK_DETS} />

              <div className="details-content">
                <Detail
                  label={LABEL_TXT.VA_BEN_ACC_NAME}
                  value={virtualBankDetails?.accHolderName || "N/A"}
                />
                <Detail
                  label={LABEL_TXT.VA_ACC_NUM}
                  value={virtualBankDetails?.accNum || "N/A"}
                />
                <Detail
                  label={LABEL_TXT.VA_IFSC_CODE}
                  value={virtualBankDetails?.ifscCode || "N/A"}
                />
                <Detail
                  label={LABEL_TXT.VA_BANK_NAME}
                  value={virtualBankDetails?.bankName || "N/A"}
                />
                <Detail
                  label={LABEL_TXT.VA_BRANCH_NAME}
                  value={virtualBankDetails?.branchName || "N/A"}
                />
              </div>
            </>
          )}

          <DetailSubHeader title={TITLE_TXT.KYC_DETS} />

          <div className="details-content">
            <Detail
              label={LABEL_TXT.PAN}
              value={bankKYCDetailsData?.kycDetails?.kycPanValue?.docValue || "N/A"}
              isVerified={bankKYCDetailsData?.kycDetails?.kycPanValue?.isVerified}
            />
            <Detail
              label={LABEL_TXT.GSTIN}
              value={bankKYCDetailsData?.kycDetails?.kycGstinValue?.docValue || "N/A"}
              isVerified={bankKYCDetailsData?.kycDetails?.kycGstinValue?.isVerified}
            />
            <Detail
              label={LABEL_TXT.BANK}
              value={bankKYCDetailsData?.kycDetails?.kycBank?.docValue || "N/A"}
              isVerified={bankKYCDetailsData?.kycDetails?.kycBank?.isVerified}
            />
          </div>
        </Spin>
      </div>
    </div>
  )
}

export default BankKYCDetails